<ion-list class="ion-hide-md-down">
  <ion-menu-toggle autoHide="false">
    <ion-item
      button
      [routerLink]="`/tabs/${AppTab.DASHBOARD}`"
      routerLinkActive="active"
      routerDirection="root"
      detail="false"
    >
      <ion-icon
        aria-hidden="true"
        src="../assets/material-symbols/swap_driving_apps_wheel_24dp.svg"
        slot="start"
      ></ion-icon>
      <ion-label>{{ 'general.nav_bar.tasks' | translate }}</ion-label>
    </ion-item>
  </ion-menu-toggle>
  <ion-menu-toggle autoHide="false">
    <ion-item
      button
      [routerLink]="`/tabs/${AppTab.IN_PROGRESS}`"
      routerLinkActive="active"
      routerDirection="root"
      detail="false"
    >
      <ion-icon
        aria-hidden="true"
        src="../assets/material-symbols/okc_freight_inprogress_24dp.svg"
        slot="start"
      ></ion-icon>
      <ion-label>{{ 'general.nav_bar.freights' | translate }}</ion-label>
    </ion-item>
  </ion-menu-toggle>
  <ion-menu-toggle autoHide="false">
    <ion-item
      button
      [routerLink]="`/tabs/${AppTab.FINISHED}`"
      routerLinkActive="active"
      routerDirection="root"
      detail="false"
    >
      <ion-icon
        aria-hidden="true"
        src="../assets/material-symbols/local_shipping_24dp.svg"
        slot="start"
      ></ion-icon>
      <ion-label>{{ 'general.nav_bar.finished' | translate }}</ion-label>
    </ion-item>
  </ion-menu-toggle>

  @if (canViewMarket()) {
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        [routerLink]="`/tabs/${AppTab.FREIGHT_AVAILABLE}`"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/storefront_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'general.nav_bar.market' | translate }}</ion-label>
        <ion-badge slot="end">{{ freightsAvailableCount() }}</ion-badge>
      </ion-item>
    </ion-menu-toggle>
  }
</ion-list>

<ion-list>
  @if (canCreateDeca()) {
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        [routerLink]="DECA_ROUTES.NEW"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/qr_code_2_add_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'general.nav_bar.create_deca' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>
  }
  @if (canViewDeca()) {
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        [routerLink]="DECA_ROUTES.LIST"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/qr_code_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'general.nav_bar.view_deca' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>
  }
</ion-list>

<ion-list>
  @if (canAdministrativeDocuments()) {
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/my-company"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/domain_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'company.my_company' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>
  }
  @if (canUploadFreights()) {
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/posted-freight"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/okc_upload_freights_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'freight.post.published_freights' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>
  }
  @if (canCrudVehicles()) {
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/vehicles"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/garage_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'general.nav_bar.vehicles' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>
  }

  @if (canCrudUsers()) {
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/users"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/group_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'general.nav_bar.users' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>
  }
</ion-list>

<ion-list>
  <ion-menu-toggle autoHide="false">
    <ion-item
      button
      routerLink="/account"
      routerLinkActive="active"
      routerDirection="root"
      detail="false"
    >
      <ion-icon
        aria-hidden="true"
        src="../assets/material-symbols/account_circle_24dp.svg"
        slot="start"
      ></ion-icon>
      <ion-label>{{ 'general.nav_bar.account' | translate }}</ion-label>
    </ion-item>
  </ion-menu-toggle>
</ion-list>
